import * as React from "react";
import { List, Datagrid, DateField, TextField, BooleanField, Filter, TextInput, useLocale, ImageField } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { allLanguages } from '../../lib/utils';

const useStyles = makeStyles(
    theme => ({
        image: {
            borderRadius: '5px',
            width: 'auto',
            maxHeight: '40px',
        }
    }));

const EventFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn resettable />
    </Filter>
);

export const EventList = (props) => {
    const classes = useStyles();
    const locale = useLocale();

    return (
        <List title="Eventos" {...props} filters={<EventFilter />} sort={{ field: 'createdAt', order: 'DESC' }}>
            <Datagrid rowClick="edit">
                <ImageField source="image[src]" label="Imagem" classes={classes} />
                <TextField source={`title[${locale}]`} label="Título" />
                {allLanguages.map(language => <BooleanField source={`published[${language.locale}]`} label={<img src={language.flag} alt={language.locale} />} />)}
                <DateField source="createdAt" label="Criado" />
            </Datagrid>
        </List>
    )
};

export default EventList;